require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-bash-for-fun-profit.json") })
        }
      }, "path---blog-bash-for-fun-profit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-bash-for-fun-profit!./.cache/json/blog-bash-for-fun-profit.json
// module id = 721
// module chunks = 231608221292675